import { formatRefillDate } from "@workspace/lib/date";
import {
  Pagination,
  PaginationContent,
  PaginationItem
} from "@workspace/web-ui/components/pagination";
// import { Button } from "@workspace/web-ui/components/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from "@workspace/web-ui/components/table"
import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
// import { RefillHistoryModal } from "./refill-history-modal";

type RefillMedicationHistory = any;

const ITEMS_PER_PAGE = 10; // Display 5 items per page

export const getRefillMedicationStatusConfig = (item: RefillMedicationHistory) => {
  const status = item.status

  const statusMap = {
    "completed": { color: "bg-[#E6FAF2] text-[#00C781] hover:bg-[#E6FAF2]", text: "Active", status: "completed" },
    "approved": { color: "bg-[#FEF2FF] text-[#942BA9]", text: "Approved", status: "approved" },
    "due": { color: "bg-[#FEEBEB] text-[#F53535] hover:bg-[#FEEBEB]", text: "Out of supply", status: "due" },
    "pending": { color: "bg-[#FFF6E7] text-[#FFAB1F]", text: "Pending", status: "pending" },
    "rejected": { color: "bg-gray-100 text-gray-600 hover:bg-gray-100", text: "Rejected", status: "rejected" },
  };

  return statusMap[status as keyof typeof statusMap] ?? {
    color: "bg-gray-100 text-gray-600",
    text: status ? status : "Unknown",
    status: status ?? "unknown",
  };
};

export interface PaymentTableProps {
  cardTitle: string;
  data: {
    medication: string,
    date: string,
    status: string
  }[]
}

const RefillHistoryTable = ({ data, cardTitle }: PaymentTableProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedRefill, setSelectedRefill] = useState<RefillMedicationHistory | null>(null);
  // const [showRefillHistory, setShowRefillHistory] = useState(false);

  // Calculate total pages
  const totalPages = Math.ceil(data.length / ITEMS_PER_PAGE);

  // Get data for the current page
  const paginatedData = data.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  return (
    <div className="flex flex-col gap-4 pb-4 bg-white rounded-lg border border-[#E6E6E6] shadow-sm">
      <div className="px-6 py-4 flex gap-2 border-b border-[#DCDCDE] w-full">
        <h2 className="text-lg font-medium text-[#2D2F35] text-left">{cardTitle}</h2>
      </div>
      <div className="flex flex-col items-center justify-center gap-2">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Medication</TableHead>
              <TableHead>Date</TableHead>
              <TableHead>Status</TableHead>
              {/* <TableHead>Action</TableHead> */}
            </TableRow>
          </TableHeader>
          <TableBody>
            {paginatedData?.map((item, index) => {
              const { color, text } = getRefillMedicationStatusConfig(item)
              return (
                <TableRow key={index}>
                  <TableCell className="font-medium">{item.medication}</TableCell>
                  <TableCell>{formatRefillDate(item.date)}</TableCell>
                  <TableCell>
                    <span
                      className={`px-3 py-1 text-xs font-medium rounded-full ${color}`}
                    >
                      {text}
                    </span>
                  </TableCell>
                  {/* <TableCell>
                    <Button onClick={() => {
                      setSelectedRefill(item)
                      setShowRefillHistory(true)
                    }}
                      variant={"outline"}>View</Button>
                  </TableCell> */}
                </TableRow>
              )

            })}
          </TableBody>
        </Table>
      </div>
      {/* Pagination */}
      <div className="flex items-center mt-4 p-5 text-gray-600 text-sm border-t">
        <div className="flex-1">
          <span className=" text-[#464B55] text-sm font-normal inline-flex gap-1 ">
            Showing <h6 className="text-[#1A202C] font-medium">{Math.min((currentPage - 1) * ITEMS_PER_PAGE + 1, data.length)}</h6> to{" "}
            <h6 className="text-[#1A202C] font-medium">{Math.min(currentPage * ITEMS_PER_PAGE, data.length)}</h6>  of <h6 className="text-[#1A202C] font-medium">{data.length}</h6> Results
          </span>
        </div>
        <div>

          <Pagination>
            <PaginationContent>
              <PaginationItem className="border rounded-md p-1 cursor-pointer">
                <ChevronLeft onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                  className={`${currentPage === 1 ? "opacity-50 pointer-events-none" : ""} `}
                />
              </PaginationItem>
              <PaginationItem className="border rounded-md p-1 cursor-pointer">
                <ChevronRight
                  onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                  className={`${currentPage === totalPages ? "opacity-50 pointer-events-none" : ""} `}
                />
              </PaginationItem>
            </PaginationContent>
          </Pagination>
        </div>
      </div>
      {/* {selectedRefill && <RefillHistoryModal refillMedication={selectedRefill} onClose={() => setShowRefillHistory(false)} open={showRefillHistory} />} */}
    </div>
  )
}

export default RefillHistoryTable